<template>
<div>
    <!-- Error/Status Popups -->
    <div class="error_popup popup-desktop" v-if="submitting" style="display:block;">
        <div class="error_box error-pop-desk">
            <img src="@/assets/images/info_icon_plan.png" loading="lazy" alt="" class="image-496">
            <div class="text-block-1101">Please wait...</div>
            <div class="text-block-1102">Submitting form!</div>
        </div>
    </div>

    <div class="error_popup popup-desktop" v-if="showDisqualify" style="display:block;">
        <div class="error_box error-pop-desk">
            <div class="text-block-1101" style="font-size: 16px;font-weight: bold;">We Cannot Proceed</div>
            <div class="text-block-1102" style="font-size: 14px;">
                {{ disqualifyMessage || 'Based on your responses, we cannot proceed with your application at this time.' }}
                <br /><br />
                If you believe there was an error in your submission, please click "Resubmit Form" below to update your information.
                <br /><br />
                If you prefer not to proceed, you can select "Process Refund" to request a refund.
            </div>
            <div class="button-model-yes-no new-yes-no" style="display: flex;justify-content: center;width: 100%;">
                <a href="#" class="button-107 w-button" @click.prevent="showDisqualify=false;" style="background-color: var(--light-green);color: #fff; text-align: center;">Resubmit Form</a>&nbsp;&nbsp;&nbsp;
                <a href="#" class="button-107 w-button" style="background-color: var(--light-blue);color: #fff; text-align: center;" @click.prevent="disqualifyUserAndRefund()">Process Refund</a>
            </div>
        </div>
    </div>

    <!-- Header/Navigation -->
    <section>
        <div class="top-nav-div">
            <div class="top-nav-elements">
                <a href="#" class="link-block-42 w-inline-block">
                    <img :src="require('@/assets/images/new_logo.png')" sizes="(max-width: 479px) 100vw, 84.03125px" :srcset="`${require('@/assets/images/new_logo.png')} 500w, ${require('@/assets/images/new_logo.png')} 800w`" loading="lazy" class="image-294">
                </a>
                <div class="form-nav-div">
                    <a href="#" class="back-link w-inline-block" @click.prevent="goBack()">
                        <div class="text-block-507">&lt;-</div>
                    </a>
                    <div class="form-progress-div">
                        <div>
                            <div class="text-block-508">Step <strong>3</strong> of <strong>3</strong></div>
                        </div>
                        <div class="form-precent-div">
                            <div class="text-block-509"><strong>{{ Math.round(((currentQuestionIndex + 1) / questions.length) * 100) }}%</strong> Complete</div>
                        </div>
                    </div>
                </div>
                <div class="div-block-1442">
                    <div class="text-block-505"></div>
                </div>
            </div>
        </div>
    </section>

    <!-- Question Content -->
    <div v-if="gettingDetails">
        <div class="dotted-loader"></div>
        <div class="h-80"></div>
    </div>
    <section class="section-7" v-else>
        <div class="questions-div setsizeonphone">
            <div class="question-content">
                <div class="question-container" v-if="currentQuestion">
                    <div class="question-div-2">
                        <!-- Question Header/Label -->
                        <div class="text-block-513" v-if="currentQuestion.question_type === 'dose_optimization'">Choose Dosage Schedule: </div>
                        <div class="text-block-513" v-else v-html="currentQuestion.label"></div>
                        <div class="form-subs" v-if="currentQuestion.description && (currentQuestion.question_type !== 'dose_optimization')" :class="{'consent-text' : currentQuestion.question_type === 'consent'}" v-html="currentQuestion.description"></div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'consent'">
                            <a href="#" class="link-block-30 w-inline-block acceptbutton" @click.prevent="handleAnswer('YES, I CONSENT to being treated with GLP-1 agonists. I have reviewed the risks and benefits above.')">
                                <div>
                                    <div class="text-block-545" style="color:#fff">YES, I CONSENT to being treated with GLP-1 agonists. I have reviewed the risks and benefits above.</div>
                                </div>
                            </a>
                            <a href="#" class="link-block-30 w-inline-block rejectconbutton" @click.prevent="handleAnswer('NO, I DO NOT consent to being treated with a GLP-1')">
                                <div>
                                    <div class="text-block-545" style="color:#000">NO, I DO NOT consent to being treated with a GLP-1</div>
                                </div>
                            </a>
                        </div>
                        <!-- Single Option/Radio Questions -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'single_option'">
                            <form>
                                <a href="#" v-for="option in currentQuestion.options" :key="option.title" :class="{'selected': isOptionSelected(option.title)}" @click.prevent="handleAnswerSingle(option)" class="link-block-30 w-inline-block">
                                    <div>
                                        <div class="text-block-545" style="color: black;">{{option.title}}</div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-></div>
                                    </div>
                                </a>
                            </form>
                        </div>
                        <!-- Updated dose_optimization template with two div-block-1977 containers -->
                        <div class="w-form" v-if="currentQuestion.question_type === 'dose_optimization'">
                            <div class="w-form">
                                <form>
                                    <!-- First row (first 3 months or all months if standard plan) -->
                                    <div class="dosage-drops-div">
                                        <div class="dose-sched-box" v-for="(month, index) in months.slice(0, 3)" :key="`month-${index}`">
                                            <div class="text-block-1241">{{ month }}</div>
                                            <select v-model="selectedDoses[index]" class="select-field-10 w-select">
                                                <option :value="null" disabled>{{ month }}</option>
                                                <option v-for="option in getDoseOptions(index)" :key="option.value" :value="option.value">
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>

                                    <!-- Second row (months 4-6) - only shown for 6-month plan -->

                                    <div class="dosage-drops-div" v-if="months.length > 3">
                                        <div class="dose-sched-box" v-for="(month, index) in months.slice(3)" :key="`month-${index+3}`">
                                            <div class="text-block-1241" v-if="index<2">{{ month }}</div>
                                            <div class="text-block-1241" v-else>Month 6-12</div>
                                            <select v-model="selectedDoses[index+3]" class="select-field-10 w-select">
                                                <option :value="null" disabled>{{ month }}</option>
                                                <option v-for="option in getDoseOptions(index+3)" :key="option.value" :value="option.value">
                                                    {{ option.label }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                    <button type="button" class="form-button w-button balugabtn" @click="handleNext" :disabled="!selectedDoses.every(dose => dose !== null && dose !== undefined)">
                                        Next ->
                                    </button>
                                </form>
                            </div>
                        </div>

                        <!-- Multiple Option/Checkbox Questions -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'multiple_option'">
                            <label class="w-checkbox checkbox-field-15 w-clearfix" v-for="option in currentQuestion.options" :key="option"> &nbsp;&nbsp;
                                <input type="checkbox" :value="option.title" :checked="isOptionSelected(option)" @change="handleCheckboxChange($event, option.title)" class="w-checkbox-input checkbox-11">
                                <span class="checkbox-label-12 w-form-label">{{option.title}}</span>
                            </label>
                            <button v-if="canProceed" @click="handleNext" class="form-button w-button balugabtn">
                                Next ->
                            </button>
                        </div>

                        <!-- Text Input -->
                        <div class="felix-form-block w-form" v-if="['text', 'textarea'].includes(currentQuestion.question_type)">
                            <div class="condition-question mb-4">
                                <textarea v-model="currentAnswer" :placeholder="currentQuestion.placeholder || currentQuestion.sublabel || 'Enter your answer here'" class="textarea w-input" @input="handleTextInput" @keydown.enter.prevent rows="3">
                            </textarea>
                            </div>
                            <button type="button" class="form-button w-button balugabtn" @click="handleNext" :class="{ 'next-button-enabled': canProceed }" :disabled="!canProceed">
                                Next ->
                            </button>
                        </div>

                        <div class="felix-form-block w-form" v-if="['string', 'integer'].includes(currentQuestion.question_type)">
                            <div class="condition-question mb-4">
                                <input type="text" v-model="currentAnswer" :placeholder="currentQuestion.placeholder || currentQuestion.sublabel || 'Enter your answer here'" class="enroll-form-text-field weight w-input" @input="handleTextInput" @keydown.enter.prevent rows="3">
                            </div>
                            <button type="button" class="form-button w-button balugabtn" @click="handleNext" :class="{ 'next-button-enabled': canProceed }" :disabled="!canProceed">
                                Next ->
                            </button>
                        </div>

                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type==='dose_radio_more'">
                            <form>
                                <a href="#" class="link-block-30 w-inline-block" v-for="option in currentQuestion.show_array" :key="option.sub_txt" @click.prevent="handleAnswer(option.baluga_ques)">
                                    <div class="div-block-1976">
                                        <div class="text-block-1239" v-html="option.main_txt"></div>
                                        <div class="text-block-1240" v-html="option.sub_txt"></div>
                                    </div>
                                    <div>
                                        <div class="text-block-546">-&gt;</div>
                                    </div>
                                </a>
                            </form>
                        </div>

                        <!-- File Upload -->
                        <div class="felix-form-block w-form" v-if="currentQuestion.question_type === 'image_upload' || currentQuestion.question_type === 'file'">
                            <div class="image-uploader">
                                <div class="upload-box" @dragover.prevent @drop.prevent="handleDrop" :class="{ 'drag-over': isDragging }" @dragenter.prevent="isDragging = true" @dragleave.prevent="isDragging = false">

                                    <input type="file" ref="fileInput" @change="handleFileChange" accept="image/*" class="file-input">

                                    <div class="upload-content">
                                        <div v-if="uploadLoading" class="loading">Processing...</div>

                                        <div v-else-if="uploadedFile" class="preview">
                                            <img :src="previewUrl" alt="Preview" v-if="previewUrl">
                                            <p class="file-info">{{ uploadedFile.name }} ({{ formatFileSize(uploadedFile.size) }})</p>
                                            <p class="upload-info">Click or drag to upload a new image</p>
                                        </div>

                                        <div v-else class="upload-prompt">
                                            <i class="upload-icon"><img src="@/assets/images/upload-icon.svg"></i>
                                            <p>Drop image here or click to upload</p>
                                            <p class="file-size-info">Maximum file size: 5 MB</p>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="uploadError" class="error-message">
                                    {{ uploadError }}
                                    <div class="error-action">Please try uploading again</div>
                                </div>
                                <div v-if="uploading && uploadProgress > 0" class="upload-progress-container">
                                    <div class="upload-progress-bar">
                                        <div class="upload-progress-fill" :style="{ width: uploadProgress + '%' }"></div>
                                    </div>
                                    <div class="upload-progress-text">Uploading... {{ Math.round(uploadProgress) }}%</div>
                                </div>
                                <button class="form-button w-button balugabtn" :disabled="!uploadedFile || uploadLoading || uploading" :class="{ 'error-state': uploadError }" @click="confirmUpload">
                                    {{ uploadButtonText }}
                                </button>
                            </div>
                        </div>

                        <!-- Informational -->
                        <div v-if="currentQuestion.question_type === 'informational'" class="info-message">

                            <button v-if="currentQuestion.has_next_button !== false" @click="handleNext" class="form-button w-button balugabtn">
                                Next ->
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div style="height: 340px;"></div>
</div>
</template>

<script>


import {
    mapGetters
} from 'vuex';

const checkOptionProperties = (question, answer) => {
    if (!question.options || !answer) return {
        important: false,
        is_critical: false
    };
    // Handle multiple choice answers
    if (Array.isArray(answer)) {
        return answer.reduce((acc, selectedAnswer) => {
            const option = question.options.find(opt => opt.title === selectedAnswer);
            if (option) {
                return {
                    important: acc.important || option.important || false,
                    is_critical: acc.is_critical || option.is_critical || false
                };
            }
            return acc;
        }, {
            important: false,
            is_critical: false
        });
    }

    // Handle single choice answers
    const option = question.options?.find(opt => opt.title === answer);
    return {
        important: option?.important || false,
        is_critical: option?.is_critical || false
    };
};

export default {
    name: 'DynamicQuestionnaire',
    props: ['productPurchased', 'currentDose'],
    components: {
        
    },
    data() {
        return {
            currentQuestionIndex: 0,
            userState: '',
            answers: {},
            multipleChoiceAnswers: {},
            maintanenceDose: 10,
            gettingDetails: true,
            baseUrl: process.env.VUE_APP_API_ENDPOINT,
            currentAnswer: '',
            questions: [],
            submitting: false,
            showDisqualify: false,
            amountPaid: 0,
            disqualifyMessage: '',
            uploadedFile: null,
            previewUrl: '',
            uploadError: '',
            uploadLoading: false,
            uploading: false,
            uploadComplete: false,
            isDragging: false,
            maxFileSizeMB: 5,
            dependencies: [],
            adjustmentType: "",
            uploadProgress: 0,
            months: [],
            drugs: {
                semaglutide: [{
                        strength: 0.25,
                        label: '0.25mg (Starting Dose)'
                    },
                    {
                        strength: 0.5,
                        label: '0.5mg'
                    },
                    {
                        strength: 1.0,
                        label: '1.0mg'
                    },
                    {
                        strength: 1.7,
                        label: '1.7mg'
                    },
                    {
                        strength: 2.4,
                        label: '2.4mg'
                    }
                ],
                tirzepatide: [{
                        strength: 2.5,
                        label: '2.5mg (Starting Dose)'
                    },
                    {
                        strength: 5.0,
                        label: '5.0mg'
                    },
                    {
                        strength: 7.5,
                        label: '7.5mg'
                    },
                    {
                        strength: 10.0,
                        label: '10.0mg'
                    },
                    {
                        strength: 12.5,
                        label: '12.5mg'
                    },
                    {
                        strength: 15.0,
                        label: '15.0mg'
                    }
                ]
            },
            selectedDrug: null,
            selectedDoses: Array(3).fill(null),
            isRefillForm: false
        }
    },

    computed: {
        ...mapGetters(['user']),
        currentQuestion() {
            return this.questions[this.currentQuestionIndex] || null
        },
        form_id() {
            return this.$route.params.id;
        },
        canProceed() {
            if (!this.currentQuestion) return false

            const answer = this.getCurrentAnswer()

            switch (this.currentQuestion.question_type) {
                case 'single_option':
                    return !!answer
                case 'multiple_option':
                    return Array.isArray(answer) && answer.length > 0
                case 'text':
                case 'string':
                case 'textarea':
                    return !!answer && answer.trim().length > 0
                case 'integer':
                    return !isNaN(answer) && answer !== null && answer !== ''
                case 'file':
                case 'image_upload':
                    return this.currentQuestion.is_optional || !!answer
                case 'informational':
                    return true
                case 'dose_optimization':
                    return this.selectedDoses.length === this.months.length && this.selectedDoses.every(dose => dose !== null && dose !== undefined)
                default:
                    return true
            }
        },
        uploadButtonText() {
            if (this.uploading) return 'Uploading...'
            if (this.uploadError) return 'Try Again'
            if (this.uploadComplete) return 'Uploaded!'
            return 'Confirm Upload'
        },

        maxFileSizeBytes() {
            return this.maxFileSizeMB * 1024 * 1024;
        }
    },

    watch: {
        currentQuestionIndex: {
            handler() {
                this.scrolltoTop();
                this.resetUploadState();

                if (this.currentQuestion && this.currentQuestion.important) {
                    this.validateAnswers();
                }
                this.saveProgressToStorage();
            }
        },
    },

    created() {
        this.detectFormType();
        this.initializeSelectedDrug(); // Add this line
        this.getOrder();
        this.initializeQuestions();
    },

    methods: {
        formatFileSize(bytes) {
            if (bytes === 0) return '0 Bytes'
            const k = 1024
            const sizes = ['Bytes', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
        },

        createPreviewUrl(file) {
            // Clean up previous preview URL to prevent memory leaks
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
            }
            this.previewUrl = URL.createObjectURL(file)
        },

        async processUploadFile(file) {
            // Reset upload state
            this.uploadError = ''
            this.uploadLoading = true
            this.uploadedFile = null
            this.previewUrl = ''
            this.uploadComplete = false
            this.uploading = false

            try {
                if (!file) {
                    throw new Error('Please select a file')
                }

                if (!file.type.startsWith('image/')) {
                    throw new Error('Please upload an image file')
                }

                // Check file size (5 MB limit)
                if (file.size > this.maxFileSizeBytes) {
                    throw new Error(`File size exceeds ${this.maxFileSizeMB} MB limit. Please choose a smaller file.`)
                }

                // Set the file and create preview
                this.uploadedFile = file
                this.createPreviewUrl(file)

                console.log('✅ File processed successfully:', file.name)

            } catch (err) {
                this.uploadError = err.message
                console.error('❌ File processing error:', err)
            } finally {
                this.uploadLoading = false
            }
        },

        handleFileChange(event) {
            const file = event.target.files[0]
            if (file) {
                this.processUploadFile(file)
            }
        },

        handleDrop(event) {
            this.isDragging = false
            const file = event.dataTransfer.files[0]
            if (file) {
                this.processUploadFile(file)
            }
        },

        generateUniqueFilename(originalName) {
            const timestamp = new Date().getTime()
            const extension = originalName.split('.').pop()
            const nameWithoutExt = originalName.split('.').slice(0, -1).join('.')
            return `${this.form_id}_${this.currentQuestion.question}_${timestamp}_${nameWithoutExt}.${extension}`
        },

        async getSignedUrl(filename, contentType) {
            try {
                const response = await fetch(`${this.baseUrl}/api/get-signed-url`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        filename,
                        content_type: contentType
                    })
                })

                if (!response.ok) {
                    throw new Error('Failed to get signed URL')
                }

                return await response.json()
            } catch (error) {
                throw new Error('Error getting signed URL: ' + error.message)
            }
        },

        async uploadToS3(signedUrl, file) {
            try {
                // Use XMLHttpRequest for real upload progress tracking instead of fetch
                return new Promise((resolve, reject) => {
                    const xhr = new XMLHttpRequest()

                    // Track upload progress - this enables the progress bar
                    xhr.upload.addEventListener('progress', (event) => {
                        if (event.lengthComputable) {
                            // Calculate and update progress percentage
                            this.uploadProgress = Math.round((event.loaded / event.total) * 100)
                            console.log(`Upload progress: ${this.uploadProgress}%`)
                        }
                    })

                    // Handle successful completion
                    xhr.addEventListener('load', () => {
                        if (xhr.status >= 200 && xhr.status < 300) {
                            this.uploadProgress = 100 // Ensure we show 100% completion
                            console.log('Upload completed successfully')
                            resolve()
                        } else {
                            reject(new Error('Failed to upload file to S3'))
                        }
                    })

                    // Handle network errors
                    xhr.addEventListener('error', () => {
                        reject(new Error('Network error during upload. Please check your internet connection.'))
                    })

                    // Handle upload cancellation
                    xhr.addEventListener('abort', () => {
                        reject(new Error('Upload was cancelled'))
                    })

                    // Configure and send the request
                    xhr.open('PUT', signedUrl)
                    xhr.setRequestHeader('Content-Type', file.type)
                    xhr.send(file)
                })

            } catch (error) {
                throw new Error('Error uploading to S3: ' + error.message)
            }
        },

        async confirmUpload() {
            if (!this.uploadedFile || this.uploading) return

            this.uploading = true
            this.uploadError = ''
            this.uploadComplete = false
            this.uploadProgress = 0 // Reset progress at start

            try {
                // Generate unique filename
                const filename = this.generateUniqueFilename(this.uploadedFile.name)
                console.log('🔄 Generated filename:', filename)

                // Get signed URL
                console.log('🔄 Requesting signed URL for:', filename)
                const urlData = await this.getSignedUrl(filename, this.uploadedFile.type)
                if (!urlData?.url) {
                    throw new Error('Failed to get upload URL')
                }
                console.log('✅ Received signed URL')

                // Upload file to S3 with progress tracking
                console.log('🔄 Starting S3 upload with file size:', this.uploadedFile.size)
                await this.uploadToS3(urlData.url, this.uploadedFile)
                console.log('✅ S3 upload completed successfully')

                await this.$nextTick()

                // Set upload complete
                this.uploadComplete = true

                // **DIRECTLY UPDATE ANSWERS AND MOVE TO NEXT QUESTION**
                console.log('📝 Setting answer for current question:', this.currentQuestion.id)
                this.$set(this.answers, this.currentQuestion.id, filename)

                console.log('✅ Upload successful, moving to next question')

                // Add a small delay to ensure UI updates, then move to next question
                setTimeout(() => {
                    this.moveToNextQuestion()
                    this.resetUploadState() // Clean up upload state
                }, 500)

            } catch (err) {
                console.error('❌ Upload error:', err)

                // Log upload attempt for debugging
                try {
                    await this.logUploadAttempt({
                        success: false,
                        errorMessage: err.message,
                        fileSize: this.uploadedFile?.size,
                        filename: this.uploadedFile?.name
                    })
                } catch (e) {
                    console.log('Failed to log upload attempt:', e)
                }

                // Set user-friendly error messages
                if (err.message.includes('Failed to fetch') || err.message.includes('Network')) {
                    this.uploadError = 'Upload failed due to connection issues. Please check your internet connection and try again.'
                } else if (err.message.includes('signed URL')) {
                    this.uploadError = 'Error preparing upload. Please try again.'
                } else if (err.message.includes('S3')) {
                    this.uploadError = 'Error uploading file. Please try again.'
                } else {
                    this.uploadError = 'The upload was unsuccessful. Please try again.'
                }
                this.uploadComplete = false
            } finally {
                this.uploading = false
                this.uploadProgress = 0 // Reset progress when done
            }
        },

        async logUploadAttempt({
            success,
            errorMessage = '',
            fileSize = 0,
            filename = ''
        }) {
            try {
                await this.$axios.post(`https://server.prioritymeds.com/api/log-upload-attempt`, {
                    success,
                    error: errorMessage,
                    userAgent: navigator.userAgent,
                    fileSize,
                    filename,
                    imageType: this.currentQuestion?.question || 'unknown',
                    idOfForm: this.form_id,
                    timestamp: new Date().toISOString()
                })
            } catch (err) {
                console.warn('Failed to log upload attempt:', err)
            }
        },

        resetUploadState() {
            // Clean up upload state when moving to next question
            if (this.previewUrl) {
                URL.revokeObjectURL(this.previewUrl)
            }
            this.uploadedFile = null
            this.previewUrl = ''
            this.uploadComplete = false
            this.uploadError = ''
            this.uploadLoading = false
            this.uploading = false
            this.isDragging = false
            this.uploadProgress = 0 // Reset progress when cleaning up state
        },
        initializeSelectedDrug() {
            if (this.productPurchased) {
                // Convert productPurchased to lowercase for comparison
                const product = this.productPurchased.toLowerCase();

                if (product.includes('tirz') || product.includes('tirzepatide')) {
                    this.selectedDrug = 'tirzepatide';
                } else if (product.includes('sema') || product.includes('semaglutide')) {
                    this.selectedDrug = 'semaglutide';
                } else {
                    // Default fallback - you can adjust this logic as needed
                    this.selectedDrug = 'semaglutide';
                }

                console.log('Selected drug based on product:', this.selectedDrug);
            }
        },
        detectFormType() {
            // Detect if this is a refill form based on route or other indicators
            this.isRefillForm = this.$route.path.includes('refill') ||
                this.$route.name === 'refill' ||
                this.productPurchased !== undefined;
        },

        getMeaintanceDose() {
            return [{
                    value: 2.5,
                    label: '2.5mg '
                },
                {
                    value: 5,
                    label: '5.0mg'
                },
                {
                    value: 7.5,
                    label: '7.5mg'
                },
                {
                    value: 10,
                    label: '10.0mg'
                },
                {
                    value: 12.5,
                    label: '12.5mg'
                },
                {
                    value: 15,
                    label: '15.0mg'
                }
            ];
        },

        goBack() {
            if (this.currentQuestionIndex <= 0) {
                return;
            }

            if (this.currentQuestion) {
                if (this.currentQuestion.question_type === 'multiple_option') {
                    this.$delete(this.multipleChoiceAnswers, this.currentQuestion.id);
                }

                this.$delete(this.answers, this.currentQuestion.id);
                this.currentAnswer = '';

                if (this.currentQuestion.question_type === 'dose_optimization') {
                    this.selectedDoses = Array(3).fill(null);
                }
            }

            let previousIndex = this.currentQuestionIndex - 1;

            while (previousIndex >= 0 && !this.shouldShowQuestion(this.questions[previousIndex])) {
                previousIndex--;
            }

            const currentQuestion = this.questions[this.currentQuestionIndex];
            if (currentQuestion.isFollowUp) {
                const parentIndex = this.questions.findIndex(q => q.id === currentQuestion.parentId);
                if (parentIndex !== -1) {
                    previousIndex = parentIndex;
                }

                this.questions = this.questions.filter(q => !q.isFollowUp || q.parentId !== currentQuestion.parentId);
            }

            if (previousIndex >= 0) {
                this.currentQuestionIndex = previousIndex;
            }
        },

        async getOrder() {
            try {
                this.months = ["Month 1", "Month 2", "Month 3"];
                this.selectedDoses = Array(3).fill(null);
            } catch (error) {
                console.error('Error fetching order:', error);
                this.$router.push('/sorry?message=An error occurred while fetching your order. Please try again later.')
            }
        },

        async initializeQuestions() {
            try {
                console.log('🔄 Fetching questions from S3 refill...');
                console.log('🔍 Current gettingDetails state BEFORE:', this.gettingDetails);

                // Ensure loading is on
                this.gettingDetails = true;
                console.log('🔄 Set gettingDetails to true');

                const response = await fetch('https://prioritymeds.s3.us-east-1.amazonaws.com/public/assets/questions/mdi_refill_3july.json');

                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                let questionsArray = data.questions || [];

                // Filter out pregnancy question if user is male
                if (this.user?.gender !== 'Female') {
                    questionsArray = questionsArray.filter(question => question.id !== '0');
                }

                this.questions = questionsArray;
                this.dependencies = data.dependency || [];

                console.log('✅ Questions loaded successfully:', questionsArray.length);

                // CRITICAL: Turn off loading - force it with $nextTick
                this.$nextTick(() => {
                    this.gettingDetails = false;
                    console.log('🔄 Loading turned OFF via $nextTick, gettingDetails:', this.gettingDetails);

                    // Double check after a short delay
                    setTimeout(() => {
                        console.log('🔍 Final gettingDetails state:', this.gettingDetails);
                        console.log('🔍 Questions length:', this.questions.length);
                        console.log('🔍 Current question:', this.currentQuestion?.label);
                    }, 100);
                });

            } catch (error) {
                console.error('❌ Error fetching questions:', error);
                this.gettingDetails = false;
                console.log('🔄 Loading turned OFF due to error');
            }
        },
        forceStopLoading() {
            console.log('🚀 Manually stopping loading...');
            this.gettingDetails = false;
            this.$forceUpdate();
        },

        getDoseOptions(monthIndex) {
            try {
                // Ensure selectedDrug is set before proceeding
                if (!this.selectedDrug) {
                    this.initializeSelectedDrug();
                }

                if (!this.selectedDrug || !this.drugs[this.selectedDrug]) {
                    console.warn('Selected drug not found, falling back to default options');
                    return [];
                }

                const availableDoses = this.drugs[this.selectedDrug];

                if (monthIndex === 0) {
                    // If currentDose prop is provided, use it to determine starting options
                    if (this.currentDose) {
                        const currentDoseValue = parseFloat(this.currentDose);
                        const currentDoseIndex = availableDoses.findIndex(dose =>
                            Math.abs(dose.strength - currentDoseValue) < 0.0001
                        );

                        if (currentDoseIndex !== -1) {
                            // Return current dose and next higher dose as options
                            const options = [availableDoses[currentDoseIndex]];

                            // Add next higher dose if available
                            if (currentDoseIndex < availableDoses.length - 1) {
                                options.push(availableDoses[currentDoseIndex + 1]);
                            }

                            // Add previous dose if available (for decrease option)
                            if (currentDoseIndex > 0) {
                                options.unshift(availableDoses[currentDoseIndex - 1]);
                            }

                            return options.map(drug => ({
                                label: drug.label || `${drug.strength}mg`,
                                value: drug.strength
                            }));
                        }
                    }

                    // If no currentDose or dose not found, return all available doses
                    return availableDoses.map(drug => ({
                        label: drug.label || `${drug.strength}mg`,
                        value: drug.strength
                    }));
                }

                // For subsequent months, base options on previous month's selection
                const prevDose = this.selectedDoses[monthIndex - 1];
                if (prevDose === null) return [];

                const currentIndex = availableDoses.findIndex(dose =>
                    Math.abs(dose.strength - prevDose) < 0.0001
                );

                if (currentIndex === -1) return [];

                const options = [];

                if (currentIndex > 0) options.push(availableDoses[currentIndex - 1]);
                options.push(availableDoses[currentIndex]);
                if (currentIndex < availableDoses.length - 1) options.push(availableDoses[currentIndex + 1]);

                return options.map(drug => ({
                    label: drug.label || `${drug.strength}mg`,
                    value: drug.strength
                }));
            } catch (error) {
                console.error('Error getting dose options:', error);
                return [];
            }
        },

        getTransitionDose(fromDrugType, fromDose, lastDoseTime) {
            const withinTwoWeeksMap = {
                'tirzepatide': {
                    2.5: 0.25,
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5,
                    0.5: 2.5,
                    1.0: 5.0,
                    1.7: 7.5,
                    2.0: 7.5,
                    2.4: 10.0,
                    2.5: 10.0
                }
            };

            const afterTwoWeeksMap = {
                'tirzepatide': {
                    2.5: 0.25,
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5,
                    0.5: 2.5,
                    1.0: 5.0,
                    1.7: 5.0,
                    2.0: 7.5,
                    2.4: 7.5,
                    2.5: 7.5
                }
            };

            const moreThanMonthMap = {
                'tirzepatide': {
                    2.5: 0.25,
                    5.0: 0.25,
                    7.5: 0.25,
                    10.0: 0.25,
                    12.5: 0.25,
                    15.0: 0.25
                },
                'semaglutide': {
                    0.25: 2.5,
                    0.5: 2.5,
                    1.0: 2.5,
                    1.7: 2.5,
                    2.0: 2.5,
                    2.4: 2.5,
                    2.5: 2.5
                }
            };

            let transitionMap;
            if (lastDoseTime === 'More than a month ago') {
                transitionMap = moreThanMonthMap;
            } else if (lastDoseTime === 'Within last 2 weeks') {
                transitionMap = withinTwoWeeksMap;
            } else {
                transitionMap = afterTwoWeeksMap;
            }

            const targetDose = transitionMap[fromDrugType][fromDose] ||
                (this.selectedDrug === 'tirzepatide' ? 2.5 : 0.25);

            return targetDose;
        },

        initializeDoses() {
            // Ensure selectedDrug is set based on productPurchased
            if (!this.selectedDrug) {
                this.initializeSelectedDrug();
            }

            // If currentDose prop is provided, use it to set initial dose progression
            if (this.currentDose && this.selectedDrug) {
                const currentDoseValue = parseFloat(this.currentDose);
                const availableDoses = this.drugs[this.selectedDrug];

                const currentDoseIndex = availableDoses.findIndex(dose =>
                    Math.abs(dose.strength - currentDoseValue) < 0.0001
                );

                if (currentDoseIndex !== -1) {
                    // Check if there's a preference from the form
                    const preferenceQuestion = this.questions.find(q => q.id === '6');
                    const preference = this.answers[preferenceQuestion?.id];

                    if (preference) {
                        this.handleSameDrugDoses(currentDoseValue, preference);
                    } else {
                        // Default to maintaining current dose for first month
                        this.selectedDoses[0] = currentDoseValue;

                        // Set subsequent months to gradual increase
                        for (let i = 1; i < this.months.length; i++) {
                            const nextIndex = Math.min(currentDoseIndex + i, availableDoses.length - 1);
                            this.selectedDoses[i] = availableDoses[nextIndex].strength;
                        }
                    }
                    return;
                }
            }

            // Fallback to existing logic if currentDose is not provided or not found
            const medQuestion = this.questions.find(q => q.question === 'current_weight_meds');
            if (!medQuestion) {
                return;
            }

            // Rest of existing logic...
            const currentMed = this.answers[medQuestion.id]?.toLowerCase();
            if (!currentMed) {
                this.selectedDoses = [null, null, null];
                return;
            }

            const isDoseTirzepatide = currentMed.includes('tirze') || currentMed.includes('mounjaro');
            const doseQuestionId = isDoseTirzepatide ? '8_2' : '8_1';
            const currentDoseQuestion = this.questions.find(q => q.id === doseQuestionId);
            if (!currentDoseQuestion || !this.answers[currentDoseQuestion.id]) {
                return;
            }

            const doseAnswer = this.answers[currentDoseQuestion.id];
            const doseMatch = doseAnswer.match(/(\d+\.?\d*)/);
            if (!doseMatch) {
                return;
            }
            const currentDose = parseFloat(doseMatch[1]);
            const currentDrugType = currentMed.includes('tirze') || currentMed.includes('mounjaro') ?
                'tirzepatide' : 'semaglutide';

            const lastDoseDateQuestion = this.questions.find(q => q.id === '8_3');
            const lastDoseDate = this.answers[lastDoseDateQuestion?.id];
            const preferenceQuestion = this.questions.find(q => q.id === '10_1');
            const preference = this.answers[preferenceQuestion?.id];
            if (!lastDoseDate || !preference) {
                return;
            }

            if (currentDrugType === this.selectedDrug) {
                this.handleSameDrugDoses(currentDose, preference);
            } else {
                const targetDose = this.getTransitionDose(currentDrugType, currentDose, lastDoseDate);
                this.setDoseProgression(targetDose, preference);
            }
        },

        handleSameDrugDoses(currentDose, preference) {
            const availableDoses = this.drugs[this.selectedDrug];
            const currentDoseIndex = availableDoses.findIndex(dose =>
                Math.abs(dose.strength - currentDose) < 0.0001
            );

            if (currentDoseIndex === -1) return;

            const monthCount = this.months.length;

            switch (preference) {
                case 'increase': {
                    const doses = [];
                    for (let i = 0; i < monthCount; i++) {
                        const targetIndex = Math.min(currentDoseIndex + 1 + i, availableDoses.length - 1);
                        doses.push(availableDoses[targetIndex].strength);
                    }
                    this.selectedDoses = doses;
                    break;
                }
                case 'same':
                    this.selectedDoses = Array(monthCount).fill(availableDoses[currentDoseIndex].strength);
                    break;
                case 'decrease': {
                    const decreaseIndex = Math.max(currentDoseIndex - 1, 0);
                    this.selectedDoses = Array(monthCount).fill(availableDoses[decreaseIndex].strength);
                    break;
                }
                default:
                    this.selectedDoses = Array(monthCount).fill(null);
            }
        },

        setDoseProgression(initialDose, preference) {
            const availableDoses = this.drugs[this.selectedDrug];
            const startIndex = availableDoses.findIndex(dose =>
                Math.abs(dose.strength - initialDose) < 0.0001
            );

            if (startIndex === -1) {
                this.selectedDoses = Array(this.months.length).fill(null);
                return;
            }

            const monthCount = this.months.length;

            switch (preference) {
                case 'increase': {
                    const doses = [];
                    for (let i = 0; i < monthCount; i++) {
                        const targetIndex = Math.min(startIndex + i, availableDoses.length - 1);
                        doses.push(availableDoses[targetIndex].strength);
                    }
                    this.selectedDoses = doses;
                    break;
                }
                case 'same':
                    this.selectedDoses = Array(monthCount).fill(availableDoses[startIndex].strength);
                    break;
                case 'decrease': {
                    const decreaseIndex = Math.max(startIndex - 1, 0);
                    this.selectedDoses = Array(monthCount).fill(availableDoses[decreaseIndex].strength);
                    break;
                }
                default:
                    this.selectedDoses = Array(monthCount).fill(null);
            }
        },

        getCurrentAnswer() {
            if (!this.currentQuestion) return null
            return this.currentQuestion.question_type === 'multiple_option' ?
                this.multipleChoiceAnswers[this.currentQuestion.id] :
                this.currentAnswer || this.answers[this.currentQuestion.id]
        },

        isOptionSelected(option) {
            const answer = this.getCurrentAnswer()
            if (typeof option === 'object') {
                return Array.isArray(answer) ? answer.includes(option.title) : answer === option.title
            }
            return Array.isArray(answer) ? answer.includes(option) : answer === option
        },

        handleCheckboxChange(event, option) {
            const questionId = this.currentQuestion.id
            let answers = [...(this.multipleChoiceAnswers[questionId] || [])]

            if (event.target.checked) {
                if (option.toLowerCase().includes('none')) {
                    answers = [option]
                } else {
                    answers = answers.filter(a => !a.toLowerCase().includes('none'))
                    answers.push(option)
                }
            } else {
                answers = answers.filter(a => a !== option)
            }

            this.$set(this.multipleChoiceAnswers, questionId, answers)
            this.$set(this.answers, questionId, answers)
        },

        handleAnswerSingle(option) {
            if (option.is_back_button) {
                this.goBack();
            } else {
                this.handleAnswer(option.title)
            }
        },

        handleAnswer(answer) {
            if (!this.currentQuestion) return
            this.$set(this.answers, this.currentQuestion.id, answer)
            this.currentAnswer = answer
            if (this.currentQuestion.question === 'next_dose_preference') {
                console.log("this is the current question ")
                this.initializeDoses();
            }
            this.moveToNextQuestion()
        },

        handleImageUploaded(data) {
            this.$set(this.answers, this.currentQuestion.id, data.filename)
            this.moveToNextQuestion()
        },

        handleNext() {
            if (!this.canProceed) return
            const answer = this.getCurrentAnswer()
            this.$set(this.answers, this.currentQuestion.id, answer)
            this.moveToNextQuestion()
        },

        handleTextInput(event) {
            this.currentAnswer = event.target.value
        },

        handleFileUpload(event) {
            const file = event.target.files[0]
            if (!file) return
            this.uploadedFile = file.name
            if (this.isImageFile(file.name)) {
                const reader = new FileReader()
                reader.onload = e => {
                    this.currentAnswer = e.target.result
                }
                reader.readAsDataURL(file)
            } else {
                this.currentAnswer = file
            }
        },

        isImageFile(name) {
            return typeof name === 'string' && /\.(jpg|jpeg|png|gif)$/i.test(name)
        },

        getFileName(file) {
            return file instanceof File ? file.name : 'File selected'
        },

        disqualifyUserAndRefund() {
            this.$emit('disqualify-user')
        },

        findNextQuestion() {
            if (!this.currentQuestion) return null
            //const currentId = this.currentQuestion.id

            // For refill questions, we don't have complex followup structures
            // Just find the next question that should be shown
            return this.findNextMainQuestion()
        },

        findNextMainQuestion() {
            for (let i = this.currentQuestionIndex + 1; i < this.questions.length; i++) {
                const question = this.questions[i]
                if (this.shouldShowQuestion(question)) {
                    return i
                }
            }
            return null
        },

        moveToNextQuestion() {
            if (this.currentQuestion) {
                const answer = this.getCurrentAnswer()
                this.$set(this.answers, this.currentQuestion.id, answer)
            }

            const nextIndex = this.findNextQuestion()
            if (nextIndex !== null) {
                this.currentQuestionIndex = nextIndex
                this.currentAnswer = ''
            } else {
                this.submitting = true
                this.handleFinalSubmit()
            }
        },

        async handleFinalSubmit() {
            this.submitting = true;
            try {
                if (this.productPurchased === 'Tirzepatide') {
                    const hasEmptyDoses = this.selectedDoses.some(dose => dose === null || dose === undefined);
                    if (hasEmptyDoses) {
                        this.selectedDoses = [2.5, 5, 7.5];
                        if (!this.maintanenceDose) {
                            this.maintanenceDose = 10;
                        }
                    }
                }
            } catch (error) {
                console.log(error)
            }

            const submissionData = {
                ...this.formatAnswers(),
                form_id: this.$route.params.id,
                userInfo: this.user,
                paymentTerms: this.amountPaid,
                maintanenceDose: this.maintanenceDose,
                productPurchased: this.productPurchased,
                isRefil: true,
                frmName: "mdIntegration"
            };

            try {
                await this.$axios.post(`https://server.prioritymeds.com/api/submit-md-form`, submissionData);
                this.submitting = false;
                this.$router.push('/verify-address');
            } catch (error) {
                console.log(error)
                this.submitting = false;
            }
        },

        formatAnswers() {
            const formattedAnswers = [];
            const images = [];

            // For refill questions, we might have simpler structure
            const additional_details = {
                allergies: '',
                current_meds: '',
                current_medical_condition: '',
                pregnancy: false
            };

            // Handle refill-specific questions
            this.questions.forEach(question => {
                if (!this.shouldShowQuestion(question)) {
                    return;
                }

                let answer = this.answers[question.id];
                if (answer === undefined) return;

                // Skip informational questions that don't have answers
                if (question.question_type === 'informational' && !answer) {
                    return;
                }

                const {
                    important,
                    is_critical
                } = checkOptionProperties(question, answer);

                const formattedAnswer = {
                    question: question.label,
                    answer: this.formatAnswerValue(answer),
                    type: this.determineAnswerType(question, answer),
                    description: question.description || '',
                    important: important || question.important || false,
                    is_critical: is_critical || question.is_critical || false,
                    label: question.label || '',
                    displayed_options: this.getDisplayedOptions(question)
                };

                if (formattedAnswer.type === 'image_upload') {
                    formattedAnswer.question = question.question;
                    images.push(formattedAnswer);
                } else {
                    formattedAnswers.push(formattedAnswer);
                }
            });

            return {
                answers: formattedAnswers,
                images: images,
                patientPreference: this.selectedDoses,
                additional_details: additional_details
            };
        },

        formatAnswerValue(answer) {
            if (Array.isArray(answer)) {
                return answer.join('\n');
            }
            return String(answer);
        },

        determineAnswerType(question, answer) {
            switch (question.question_type) {
                case 'single_option':
                case 'multiple_option':
                case 'text':
                case 'textarea':
                case 'string':
                    return 'string';
                case 'integer':
                    return 'number';
                case 'file':
                case 'image_upload':
                    return 'image_upload';
                default:
                    return typeof answer;
            }
        },

        getDisplayedOptions(question) {
            if (question.options && Array.isArray(question.options)) {
                return question.options.map(option => option.title);
            }
            return [];
        },

        validateAllAnswers() {
            const requiredQuestions = this.questions.filter(q =>
                !q.is_optional && this.shouldShowQuestion(q)
            );

            return requiredQuestions.every(question => {
                const answer = this.answers[question.id];
                return !(answer === undefined || answer === '' ||
                    (Array.isArray(answer) && answer.length === 0));
            });
        },

        shouldShowQuestion(question) {
            // Handle state restriction for refill questions
            if (question.question === 'state_restriction') {
                // Check if user is in restricted states (MS, LA, or other restricted states)
                const restrictedStates = ['MS', 'LA', 'restricted_states'];
                return restrictedStates.includes(this.userState);
            }

            // Skip Florida Bill of Rights question if user is not in Florida
            if (question.question === 'florida_bill_of_rights' && this.userState && this.userState.toLowerCase() !== 'fl' && this.userState.toLowerCase() !== 'florida') {
                return false;
            }

            if (question.isFollowUp) {
                return true
            }

            const deps = this.dependencies.filter(d => d.question_id === question.id)
            if (!deps.length) return true

            return deps.every(dep => {
                // Handle user_state dependency for refill questions
                if (dep.dependent_on === 'user_state') {
                    return dep.ask_if_val_in.includes(this.userState);
                }

                const parentAnswer = this.answers[dep.dependent_on]
                if (!parentAnswer) return false

                if (Array.isArray(parentAnswer)) {
                    return parentAnswer.some(answer => dep.ask_if_val_in.includes(answer))
                }

                return dep.ask_if_val_in.includes(parentAnswer)
            })
        },

        validateAnswers() {
            const currentQuestion = this.currentQuestion;
            if (!currentQuestion) return true;

            // Handle informational questions with no next button (disqualifying)
            if (currentQuestion.question_type === 'informational' && currentQuestion.has_next_button === false) {
                this.disqualifyMessage = currentQuestion.description || 'We cannot proceed with your application at this time.';
                this.showDisqualify = true;
                return false;
            }

            if (currentQuestion.question_type === 'single_option') {
                const currentAnswer = this.getCurrentAnswer();
                const hasFollowup = this.dependencies.some(dep =>
                    dep.dependent_on === currentQuestion.id &&
                    dep.ask_if_val_in.includes(currentAnswer)
                );

                if (hasFollowup) {
                    return true;
                }
            }

            if (['text', 'textarea', 'image_upload'].includes(currentQuestion.question_type)) {
                return true;
            }

            // Check for critical options that should trigger warnings or disqualification
            const answer = this.getCurrentAnswer();
            const {
                important,
                is_critical
            } = checkOptionProperties(currentQuestion, answer);
            console.log(important)
            if (is_critical && currentQuestion.question_type !== 'informational') {
                // For refill questions, critical answers might need special handling
                // but don't automatically disqualify unless it's an informational question
                return true;
            }

            return true;
        },

        scrolltoTop() {
            window.scrollTo(0, 0);
        }
    }
}
</script>

<style scoped>
.selected {
    background-color: #f0f0f0;
}

.file-upload-container {
    margin-bottom: 1rem;
}

.file-preview {
    margin-top: 1rem;
}

.image-preview {
    max-width: 200px;
    max-height: 200px;
    object-fit: contain;
}

.file-name {
    margin-top: 0.5rem;
    font-size: 0.9rem;
    color: #666;
}

.next-button-enabled {
    opacity: 1;
    cursor: pointer;
}

.next-button-enabled:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.info-message {
    padding: 1rem;
    background-color: #f8f9fa;
    border-radius: 4px;
    margin-bottom: 1rem;
}

.checkbox-field-15 {
    display: flex;
    align-items: center;
    margin-bottom: 0.5rem;
}

.checkbox-11 {
    margin-right: 0.5rem;
}

.acceptbutton {
    background-color: var(--light-green) !important;
    border: none;
    color: #fff
}

.rejectconbutton {
    background-color: transparent !important;
    height: 20px;
    border: none;
    text-align: center;
    justify-content: center;
}

.rejectconbutton .text-block-545 {
    font-size: 12px !important;
}

.dose-sched-box {
    width: 32%;
    padding: 10px 2px;
}

.select-field-10 {
    width: 72%;
}

@media (max-width: 768px) {
    .setsizeonphone {
        max-width: 100%;
        padding-right: 10px;
        padding-left: 10px;
    }
}

@media screen and (max-width: 479px) {
    .dose-sched-box.solo {
        width: 100%;
    }
}

.image-uploader {
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
}

.upload-box {
    position: relative;
    border: 2px dashed #ccc;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    margin-bottom: 15px;
}

.upload-box:hover {
    border-color: #666;
}

.drag-over {
    border-color: #2196F3;
    background-color: rgba(33, 150, 243, 0.1);
}

.file-input {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0;
    cursor: pointer;
}

.upload-content {
    padding: 20px;
}

.upload-icon {
    font-size: 48px;
    margin-bottom: 10px;
}

.upload-prompt p {
    margin: 10px 0;
    font-size: 16px;
    color: #666;
}

.file-size-info {
    font-size: 14px;
    color: #999;
    margin-top: 5px;
}

.file-info {
    font-size: 14px;
    color: #333;
    font-weight: 500;
    margin: 5px 0;
}

.upload-info {
    font-size: 14px;
    color: #999;
}

.preview {
    margin: 10px 0;
}

.preview img {
    max-width: 100%;
    max-height: 300px;
    border-radius: 4px;
    margin-bottom: 10px;
}

.loading {
    padding: 20px;
    color: #666;
}

.error-message {
    color: #f44336;
    margin-top: 10px;
    font-size: 14px;
    padding: 10px;
    background-color: #ffebee;
    border-radius: 4px;
    border: 1px solid #ffcdd2;
}

.error-action {
    margin-top: 5px;
    font-weight: 500;
}

.error-state {
    background-color: #f44336 !important;
    border-color: #d32f2f !important;
}

.error-state:hover {
    background-color: #d32f2f !important;
}

/* Add these styles to your existing <style scoped> section */

/* Upload Progress Bar Styles */
.upload-progress-container {
    margin-bottom: 15px;
}

.upload-progress-bar {
    width: 100%;
    height: 8px;
    background-color: #f0f0f0;
    border-radius: 4px;
    overflow: hidden;
    margin-bottom: 8px;
}

.upload-progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #2196F3, #21CBF3);
    transition: width 0.3s ease;
    border-radius: 4px;
}

.upload-progress-text {
    text-align: center;
    font-size: 14px;
    color: #666;
    font-weight: 500;
}
</style>
